<template>
  <BaseTemplate :currentUser="currentUser" :isTop="true" :banner="corporationBanner">
    <div v-if="packList" class="top">
      <div class="_pack_list">
        <div class="product-list">
          <ProductBanner v-for="(packItem) in productList" :key="packItem.id"
            class="banner"
            top="true"
            :data-pack-id="packItem.id"
            :packItem="packItem" :currentUser="currentUser"
            :isStore="true"
            @handleCardHide="CardHideChange"
            @handlePassword="PasswordInputChange"
            @handleLoginClick="goToLogin"
            @handleBuyClick="goToConfirmBuyProduct"
          />
        </div>
      </div>
    </div>
    <CommonOverlay class="overlay" v-show="isPassword" @handleOverlayClick="isPassword = false">
      <CommonModal class="modal">
        <div>
          {{t('パスワード入力')}}
        </div>
        <TextBox class="text-box" v-model="password"/>
        <ErrorMessage
          v-if="errorMessagePackPass"
          class="error-message"
          :message="errorMessagePackPass"
        />
        <div class="modal-button-area">
          <BuyButton
            :isArrow="false"
            class="send-button"
            :text="t('送信')"
            @handleSquareBtnClick="savePassword"
          />
          <SquareButton
            class="square-button"
            text="close"
            :isSub="true"
            @handleSquareBtnClick="isPassword = false"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay class="overlay" v-show="isImageModal">
      <CommonModal class="modal">
        <div>
          <img class="overlay_image" :src="imageUrl" alt="">
        </div>
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            text="close"
            :isSub="true"
            @handleSquareBtnClick="isImageModal = false"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay class="overlay register-country" v-show="isCountryPopup">
      <CommonModal class="modal">
        <div class="register-country-title">In order to prevent unauthorized access, we ask for your cooperation in selecting the country name.</div>
        <SelectBox
          class="register-country-select"
          :options="countryList"
          :selectedOption="countryId"
          @handleSelectChange="changeCountry"
        />
        <ErrorMessage
          v-if="errorMessageCountryId"
          class="error-message"
          :message="errorMessageCountryId"
        />
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            text="save"
            :isSub="true"
            @handleSquareBtnClick="saveCountry"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay class="overlay" v-show="hideCard" @handleOverlayClick="hideCard = false">
      <CommonModal class="modal">
        <div>
          {{t('本商品の内容は全て非公開となります。')}}
        </div>
        <div class="modal-button-area">
          <SquareButton
            class="square-button"
            text="close"
            :isSub="true"
            @handleSquareBtnClick="hideCard = false"
          />
        </div>
      </CommonModal>
    </CommonOverlay>

    <CommonOverlay class="overlay_conf" v-show="isOpenConfirm">
      <CommonModal class="modal pack-confirm">
        <GrayCloseButton
          class="close_button"
          @handleClick="closeModal"
        ></GrayCloseButton>
        <div class="block">
          <template v-if="isJP">
            <div>{{ buyCoin | comma }}{{ t('コインを')}}</div>
            <div>{{ t('消費して') }}<br>{{ count | comma }}{{ t('回ガチャを引く') }}</div>
          </template>
          <template v-else>
            <div>
              {{ t('を消費し') }} {{ buyCoin | comma }} {{ buyCoin <= 1 ? 'coin' : 'coins' }} {{ t('回ガチャを引く') }}
            </div>
          </template>
        </div>
        <div class="modal-button-area">
          <SimpleButton
            class="purchase-btn"
            :isArrow="false"
            @handleSquareBtnClick="buyPack"
          />
          <SimpleButton
            class="purchase-btn cancel-btn"
            :isArrow="false"
            :text="t('キャンセル')"
            @handleSquareBtnClick="closeModal"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
  </BaseTemplate>
</template>

<script>
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';
import { separateCharacterNumber } from '@/common/util/format';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ProductBanner from '@/components/molecules/ProductBanner.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import GrayCloseButton from '@/components/atoms/GrayCloseButton.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import SelectBox from '@/components/atoms/SelectBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';
import SimpleButton from '@/components/atoms/SimpleButton.vue';
import TextBox from '@/components/atoms/TextBox.vue';

export default {
  name: 'Store',

  components: {
    BaseTemplate,
    ProductBanner,
    CommonOverlay,
    CommonModal,
    GrayCloseButton,
    SquareButton,
    SelectBox,
    ErrorMessage,
    BuyButton,
    SimpleButton,
    TextBox,
  },

  data: () => ({
    productList: [],
    inputBoard: false,
    // showCardType: 1,
    isImageModal: false,
    imageUrl: '',
    isCountryPopup: false,
    errorMessagePackPass: null,
    countryId: '',
    errorMessageCountryId: null,
    errorMessageCount: null,
    isOpenConfirm: false,
    currentPack: null,
    isPassword: false,
    count: 1,
    hideCard: false,
    targetPackId: null,
    shouldScrollToPack: false,
  }),
  mixins: [t],

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      packList: 'pack/packList',
      cardTypeList: 'cardType/companyCardTypeList',
      showCardType: 'pack/topCardType',
      postList: 'post/postList',
      page: 'post/page',
      countryCheckResult: 'country/countryCheckResult',
      countryList: 'country/countryList',
      changeUserInformationResult: 'user/changeUserInformationResult',
      packCheckResult: 'pack/packCheckResult',
      buyPackResult: 'pack/buyPackResult',
      savePackPassword: 'pack/savePackPassword',
      currentLanguage: 'user/currentLanguage',
    }),
    isJP() {
      return this.currentLanguage === 'ja';
    },
    postItemList() {
      if (this.postList.list) {
        const formattedItemList = this.postList.list.map((item) => (
          {
            ...item,
            name:
              process.env.VUE_APP_LANG_MODE === 'en'
                ? `${item.lastName} ${item.middleName} ${item.firstName}` : `${item.lastName} ${item.firstName}`,
          }
        ), []);
        return formattedItemList;
      }
      return [];
    },
    buyCoin() {
      if (this.currentPack) {
        return this.currentPack.point * this.count;
      }
      return 0;
    },
    corporationBanner() {
      return this.productList[0] ? this.productList[0].corporation_banner : null;
    },
  },

  watch: {
    packList(newList) {
      this.productList = newList.list;
      // パックリストが読み込まれた後、指定されたパックIDにスクロール
      if (this.shouldScrollToPack && this.targetPackId) {
        this.$nextTick(() => {
          this.scrollToPackId(this.targetPackId);
          this.shouldScrollToPack = false;
          this.targetPackId = null;
        });
      }
      // for (let i = 0; i < newList.list.length; i += 1) {
      //   const ids = newList.list[i].corporation_category_id;
      //   ids.forEach((id) => {
      //     if (!this.productList[id]) {
      //       this.productList[id] = [];
      //     }
      //     this.productList[id].push(newList.list[i]);
      //   });
      // }
    },
    savePackPassword(newVal) {
      if (newVal?.status === 'error') {
        this.errorMessagePackPass = newVal.message;
      } else {
        this.errorMessagePackPass = null;
        this.isPassword = false;
        this.password = '';
        // card_hide_flagチェック: 非公開の場合はページにとどまる
        const pack = this.productList.find(p => String(p.id) === String(this.packId));
        if (pack && pack.card_hide_flag === 1) {
          // パス保存後に再取得
          this.productList = [];
          this.$store.dispatch('pack/setPackList', { categoryId: '13', url: this.$route.params.url });
        } else {
          // 戻る操作時にスクロール位置を復元するため、sessionStorageに保存
          sessionStorage.setItem('lastPackId', String(this.packId));
          // パスワード解除後に詳細ページへ遷移
          this.$router.push({ path: '/store-pack-detail', query: { packId: this.packId } });
        }
      }
    },
    changeUserInformationResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearChangeUserInformationResult');
          this.isCountryPopup = false;
        } else {
          const {
            country_id: countryId,
          } = newVal.errors;
          this.errorMessageCountryId = countryId ? countryId[0] : null;
        }
      }
    },
    packCheckResult(newVal) {
      if (newVal) {
        if (newVal.state === 200 && newVal.result === '1') {
          this.$store.dispatch('pack/clearPackCheckResult');
          this.isOpenConfirm = true;
        } else {
          const { count } = newVal.errors;
          this.errorMessageCount = count ? count[0] : null;
          alert(this.errorMessageCount);
        }
      }
    },
  },

  created() {
    this.$store.dispatch('pack/setPackList', { categoryId: '13', url: this.$route.params.url });

    // sessionStorageからパックIDを復元（パック詳細から戻った場合）
    const savedPackId = sessionStorage.getItem('lastPackId');
    if (savedPackId) {
      sessionStorage.removeItem('lastCardType');
      sessionStorage.removeItem('lastPackId');
      this.targetPackId = savedPackId;
      this.shouldScrollToPack = true;
    }
  },

  methods: {
    goToProductDetail(packId) {
      this.$router.push({ path: '/pack-detail', query: { packId } });
    },
    goToLogin() {
      this.$store.dispatch('user/setShowLoginPage', true);
    },
    changeCurrentPageCount(pageNumber) {
      console.log(pageNumber);
    },
    savePost({ content, images }) {
      const postParams = {
        content,
        images,
      };
      this.$store.dispatch('post/savePost', { postParams });
    },
    PasswordInputChange(packId) {
      this.packId = packId;
      this.isPassword = true;
    },
    savePassword() {
      const postParams = {
        pack_id: this.packId,
        password: this.password,
      };
      this.$store.dispatch('pack/setSavePackPassword', { postParams });
    },
    closeSavePost() {
      this.inputBoard = false;
    },
    showInputArea() {
      this.inputBoard = true;
    },
    clickImage(image) {
      this.isImageModal = true;
      this.imageUrl = image;
    },
    changeCountry(countryId) {
      this.countryId = countryId;
    },
    saveCountry() {
      const postParams = {
        country_id: this.countryId,
      };
      this.$store.dispatch('user/changeUserInformation', { postParams });
    },
    goToConfirmBuyProduct(pack, count) {
      if (this.currentUser.is_login === '0') {
        this.$router.push({ path: '/' });
        this.$store.dispatch('user/setShowLoginPage', true);
        return;
      }
      const postParams = {
        pack_id: pack.id,
        count: String(count),
      };
      this.currentPack = pack;
      this.count = count;
      this.$store.dispatch('pack/setCheckPackResult', { postParams });
    },
    closeModal() {
      this.isOpenConfirm = false;
    },
    buyPack() {
      (async () => {
        await this.$store.dispatch('pack/buyPack');
        const { buyPackResult } = this;
        const isSuceess = buyPackResult.state === 200 && buyPackResult.result === '1';
        if (isSuceess) {
          this.$store.dispatch('pack/clearBuyPackResult');
          this.$router.push('/gacha-animation');
        } else {
          const { count } = buyPackResult.errors;
          window.alert(count);
          this.isOpenConfirm = false;
        }
      })();
    },
    goToStoreCorporation() {
      this.$router.push('/store-corporation');
    },
    CardHideChange() {
      this.hideCard = true;
    },
    scrollToPackId(packId) {
      let lastTop = -1;
      let stableCount = 0;
      const check = (attempts) => {
        const packElement = document.querySelector(`[data-pack-id="${packId}"]`);
        if (!packElement) {
          if (attempts < 50) {
            setTimeout(() => check(attempts + 1), 200);
          }
          return;
        }
        const currentTop = packElement.getBoundingClientRect().top + window.scrollY;
        if (Math.abs(currentTop - lastTop) < 1) {
          stableCount += 1;
        } else {
          stableCount = 0;
        }
        lastTop = currentTop;
        if (stableCount >= 3) {
          packElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (attempts < 50) {
          setTimeout(() => check(attempts + 1), 200);
        } else {
          packElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      };
      this.$nextTick(() => check(0));
    },
  },
};
</script>

<style lang="scss" scoped>
._pack_list {
  margin: 0 auto 50px auto;
  max-width: 1600px;

  .banner_list {
    position: relative;

    ._title {
      color: $white;
      text-align: center;
      font-size: 24px;
      font-weight: bold;
    }

    .list_button {
      border-radius: 5px;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}

.top {
  width: 100%;
  max-width: 1600px;
  min-height: 100%;
  margin: 0 auto;

  .product-list {
    display: flex;
    padding: 14px 0;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .banner {
    margin-bottom: 20px;
    width: 49.5%;
    @media screen and (max-width: 680px) {
      width: 100%;
    }
  }

  .pc {
    display: block;
  }

  .sp {
    display: none;
  }
}
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #707070;
  width: 100%;

  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 62px;
    }
  }
}

.no_item_list {
  color: $white;
  text-align: center;
  margin-top: 20px;
}

.post_button_area {
  text-align: center;
  margin-bottom: 10px;
}

.post_list {
  background-color: $backColor;
  color: #FFF;
  margin-top: 15px;
  padding: 15px;
  border-radius: 10px;
  .content {
    white-space: pre-wrap;
  }
  .images {
    display: flex;
    flex-wrap: wrap;
    .image {
      flex: 0 0 20%;
      max-width: 20%;
      padding: 5px;
      box-sizing: border-box;
      img {
        width: 100%;
        height: auto;
        cursor: pointer;
      }
    }
  }
}

.box-pager {
  margin-top: 20px;
}

.modal {
  box-shadow: 10px 10px 10px 5px rgba(0, 0, 0, 0.6);
  width: auto;
  padding: 30px 30px;
  color: $mainColor;
  font-size: 20px;
  .send-button{
    padding: 10px;
    width: 100%;
    font-size: 16px;
  }
  .modal-button-area{
    margin-top:20px;
  }
}
@media screen and (max-width: 1200px) {
  .top {
    padding-top: 0;

    .pack_menu_list {
      justify-content: center;

      .pack_menu {
        width: 64px;
        min-width: 64px;
        font-size: 13px;
      }
    }
  }
}

@media screen and (max-width: $tabletWidth) {
  ._pack_list {
    margin: 0;

    .banner_list {
      ._title {
        color: $white;
        text-align: center;
        font-size: 20px;
        font-weight: bold;
      }
    }
  }

  .top {
    .pc {
      display: none;
    }

    .sp {
      display: block;
    }

    .sub_title {
      padding: 5px 0;
      margin-top: 30px;

      span {
        font-size: 14px;
        margin-right: 4px;
      }

      div {
        font-size: 10px;
        width: 50px;
        padding: 10px 5px;
        border-radius: 100px;
        text-align: center;

        &:hover {
          opacity: 1;
        }
      }
    }
  }
}

.overlay {
  overflow: auto;
}

.pack-confirm {
  border-radius: 10px;
  max-width: 600px;
  min-width: 400px;
  padding: 30px;
  position: relative;
  .block {
    padding: 30px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 10px 20px;
    font-weight: bold;
    color: $gray2;
    text-align: center;
    div {
      text-align: center;
    }
  }
  .close_button {
    position: absolute;
    right: 7px;
    top: 15px;
  }
  @media screen and (max-width: $mobileWidth) {
    max-width: 90vw;
    min-width: 320px;
    padding: 40px 20px;
    min-height: 400px;
    .block {
      padding: 20px 10px;
    }
  }
}
.overlay_conf {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
  .modal-button-area {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    gap: 30px;
    margin-top: 40px;
    .purchase-btn {
      width: 48%;
    }
    @media screen and (max-width: $mobileWidth) {
      flex-direction: column;
      margin: 40px 0;
      align-items: center;
      gap: 25px;
      .purchase-btn {
        width: 100%;
        max-width: 165px;
      }
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .overlay {
    justify-content: flex-start!important;
    align-items: flex-start!important;
    margin-top: 70px;
    padding-bottom: 70px;
    .overlay_image {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
.register-country {
  .register-country-title {
    text-align: center;
    font-size: 24px;
    margin-bottom: 20px;
  }
  .register-country-select {
    margin-bottom: 20px;
  }
}
@media screen and (max-width: $tabletWidth) {
  .overlay.register-country {
    justify-content: center!important;
    align-items: center!important;
  }
}
</style>
